import React from "react";

function PlusIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
            <path
                d="M10 17.5C9.8187 17.5 9.64482 17.428 9.51663 17.2998C9.38843 17.1716 9.31641 16.9977 9.31641 16.8164V4.18359C9.31641 4.00229 9.38843 3.82842 9.51663 3.70022C9.64482 3.57202 9.8187 3.5 10 3.5C10.1813 3.5 10.3552 3.57202 10.4834 3.70022C10.6116 3.82842 10.6836 4.00229 10.6836 4.18359V16.8164C10.6836 16.9977 10.6116 17.1716 10.4834 17.2998C10.3552 17.428 10.1813 17.5 10 17.5Z"
                fill="#20335B"
            />
            <path
                d="M16.3164 11.1836H3.68359C3.50229 11.1836 3.32842 11.1116 3.20022 10.9834C3.07202 10.8552 3 10.6813 3 10.5C3 10.3187 3.07202 10.1448 3.20022 10.0166C3.32842 9.88843 3.50229 9.81641 3.68359 9.81641H16.3164C16.4977 9.81641 16.6716 9.88843 16.7998 10.0166C16.928 10.1448 17 10.3187 17 10.5C17 10.6813 16.928 10.8552 16.7998 10.9834C16.6716 11.1116 16.4977 11.1836 16.3164 11.1836Z"
                fill="#20335B"
            />
        </svg>
    );
}

export default PlusIcon;
